export const useLastRoute = () => useNuxtApp().$lastRoute;
